import { render } from "./FaceGet.vue?vue&type=template&id=b045164c&scoped=true"
import script from "./FaceGet.vue?vue&type=script&lang=js"
export * from "./FaceGet.vue?vue&type=script&lang=js"

import "./FaceGet.vue?vue&type=style&index=0&id=b045164c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b045164c"]])

export default __exports__